var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { column: _vm.isMobile } },
    [
      _vm.currentLoad
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.currentLoad.humanId,
              sponsor: _vm.loadGroupSponsorName(_vm.currentLoad),
              origin: _vm._f("originName")(_vm.currentLoad.loadGroup.details),
              destination: _vm._f("destinationName")(
                _vm.currentLoad.loadGroup.details
              ),
              count: _vm.currentLoad.loadCount || 1,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.currentLoad.loadGroup
            },
            on: {
              cancel: _vm.closeCopyLoadDialog,
              newLoad: function($event) {
                return _vm.closeCopyLoadDialog($event)
              }
            },
            model: {
              value: _vm.showCopyLoadDialog,
              callback: function($$v) {
                _vm.showCopyLoadDialog = $$v
              },
              expression: "showCopyLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("edit-nickname-dialog", {
        attrs: { load: _vm.currentLoad },
        on: { refresh: _vm.refreshLoad },
        model: {
          value: _vm.showNicknameModal,
          callback: function($$v) {
            _vm.showNicknameModal = $$v
          },
          expression: "showNicknameModal"
        }
      }),
      _vm._v(" "),
      _vm.selectedLoad
        ? [
            _c(
              "toolbar",
              {
                attrs: { title: "Repeating Load: " + _vm.currentLoad.humanId }
              },
              [
                _c(
                  "v-icon",
                  {
                    on: {
                      click: function($event) {
                        return _vm.onRefresh()
                      }
                    }
                  },
                  [_vm._v("refresh")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("v-breadcrumbs", { attrs: { items: _vm.breadcrumbItems } })
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-master-detail-pane",
        {
          attrs: { selected: _vm.currentLoad },
          on: {
            reset: function($event) {
              return _vm.selectCurrentLoad(null)
            }
          }
        },
        [
          _c(
            "template",
            { slot: "master" },
            [
              _c(
                "v-load-nav-list",
                {
                  attrs: {
                    "search-prompt": "Search Repeating Loads",
                    title: "Repeating (" + _vm.repeatingLoads.length + ")",
                    "accurate-since": _vm.loadTemplatesAccurateSince,
                    loads: _vm.repeatingLoads,
                    "customer-loads": _vm.groupedBySponsorLoads,
                    loading: _vm.loadingLoadTemplates
                  },
                  on: {
                    "update:searchTerm": function($event) {
                      _vm.search = $event
                    },
                    refresh: _vm.getLoadTemplates
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "loadTile",
                      fn: function(ref) {
                        var idx = ref.idx
                        var load = ref.load
                        return [
                          _c(
                            "v-list-tile",
                            {
                              key:
                                "unassigned_load_" + idx + "_" + load.humanId,
                              class: {
                                "primary lighten-1": _vm.isSelectedLoad(load)
                              },
                              attrs: {
                                inactive: _vm.isSelectedLoad(load),
                                ripple: "",
                                avatar: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.selectCurrentLoad(load)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-tile-content",
                                [
                                  _vm._.get(load, "nickname", false)
                                    ? _c("v-list-tile-title", [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(load.nickname) +
                                            "\n              "
                                        )
                                      ])
                                    : _c("v-list-tile-title", [
                                        _vm._v(
                                          _vm._s(_vm.loadGroupSponsorName(load))
                                        )
                                      ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-sub-title",
                                    { staticClass: "text--primary" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.loadGroupPickupLocation(load)
                                              .googlePlace.region
                                          ) +
                                          "\n                to " +
                                          _vm._s(
                                            _vm.loadGroupDropoffLocation(load)
                                              .googlePlace.region
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-sub-title", [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(load.loadCount) +
                                        " trucks, " +
                                        _vm._s(
                                          _vm.distanceLabel(load.loadedMiles)
                                        ) +
                                        "\n                "
                                    ),
                                    load.billableAmount
                                      ? _c("span", [
                                          _vm._v(
                                            ", $" + _vm._s(load.billableAmount)
                                          )
                                        ])
                                      : _vm._e()
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isProducerWithPermissions
                                ? _c(
                                    "v-list-tile-avatar",
                                    { staticClass: "pa-0" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ma-0",
                                          attrs: {
                                            color: "accent",
                                            fab: "",
                                            flat: "",
                                            small: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              $event.preventDefault()
                                              return _vm.openCopyLoadDialog(
                                                load
                                              )
                                            }
                                          }
                                        },
                                        [_c("v-icon", [_vm._v("redo")])],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            key:
                              "unassigned_divider_" +
                              idx +
                              "_" +
                              load.listingHumanId
                          })
                        ]
                      }
                    },
                    {
                      key: "customerLoadsTile",
                      fn: function(skope) {
                        return [
                          _c(
                            "v-list-group",
                            { key: "groupedBy_" + skope.idx },
                            [
                              _c(
                                "v-list-tile",
                                {
                                  attrs: { slot: "activator" },
                                  slot: "activator"
                                },
                                [
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(skope.loads.length) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-tile-title", [
                                    _vm._v(_vm._s(skope.sponsor))
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(skope.loads, function(load) {
                                return [
                                  _c(
                                    "v-list-tile",
                                    {
                                      key: "grouped_load_" + load.humanId,
                                      class: {
                                        "primary lighten-1": _vm.isSelectedLoad(
                                          load
                                        )
                                      },
                                      attrs: {
                                        inactive: _vm.isSelectedLoad(load),
                                        ripple: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectCurrentLoad(load)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          load.nickname
                                            ? _c("v-list-tile-title", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(load.nickname) +
                                                    "\n                  "
                                                )
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.loadGroupPickupLocation(
                                                    load
                                                  ).googlePlace.region
                                                ) +
                                                "\n                    to " +
                                                _vm._s(
                                                  _vm.loadGroupDropoffLocation(
                                                    load
                                                  ).googlePlace.region
                                                ) +
                                                "\n                  "
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(load.loadCount) +
                                                " trucks, " +
                                                _vm._s(
                                                  _vm.distanceLabel(
                                                    load.loadGroup.details
                                                      .loadedMiles
                                                  )
                                                ) +
                                                "\n                    "
                                            ),
                                            _vm._.get(
                                              load,
                                              "loadGroup.amount",
                                              false
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    ", $" +
                                                      _vm._s(
                                                        load.loadGroup.amount
                                                      )
                                                  )
                                                ])
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("v-divider", {
                                    key: "load_divider_" + load.humanId
                                  })
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      }
                    }
                  ])
                },
                [_c("template", { slot: "subheader" })],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "detail" },
            [
              _c(
                "v-layout",
                { attrs: { column: "" } },
                [
                  _c(
                    "v-load-group-details",
                    {
                      attrs: {
                        repeating: "",
                        "read-only": !_vm.allowEdition,
                        "planning-load": _vm.currentLoad,
                        company: _vm.company,
                        "banner-title": "The Repeating Load Tool",
                        loading: _vm.loadingBtn
                      },
                      on: {
                        onFormChange: function($event) {
                          return _vm.editionFormChange($event)
                        },
                        savingLoad: function($event) {
                          return _vm.updateSavingState($event)
                        },
                        updateLoad: function($event) {
                          return _vm.updateLoad($event)
                        },
                        reload: function($event) {
                          return _vm.refreshLoad()
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        { attrs: { slot: "notSelected" }, slot: "notSelected" },
                        [
                          _vm._v(
                            "\n            Here you'll find loads offered by other carriers and " +
                              _vm._s(_vm.$t("booked-load.producers", 2)) +
                              " in your Preferred Carriers.\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "template",
                        { slot: "toolbarButtons" },
                        [
                          _vm.allowEdition
                            ? [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "accent",
                                      disabled: _vm.savingLoad
                                    },
                                    on: { click: _vm.toggleEdition }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c("v-icon", [_vm._v("clear")]),
                                        _vm._v(
                                          "\n                  Ignore\n                "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "accent",
                                      loading: _vm.savingLoad
                                    },
                                    on: { click: _vm.saveDetailsUpdates }
                                  },
                                  [
                                    _c(
                                      "v-layout",
                                      { attrs: { column: "" } },
                                      [
                                        _c("v-icon", [_vm._v("save")]),
                                        _vm._v(
                                          "\n                  Save\n                "
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _c(
                                "v-btn",
                                {
                                  attrs: { flat: "", color: "accent" },
                                  on: { click: _vm.toggleEdition }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { column: "" } },
                                    [
                                      _c("v-icon", [_vm._v("edit")]),
                                      _vm._v(
                                        "\n                Edit\n              "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "accent" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.openNicknameModal.apply(
                                    null,
                                    arguments
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("vpn_key")]),
                                  _vm._v(
                                    "\n                Nickname\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "accent" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.remove(_vm.currentLoad)
                                }
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("delete")]),
                                  _vm._v(
                                    "\n                Delete\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", color: "accent" },
                              on: {
                                click: function($event) {
                                  return _vm.openCopyLoadDialog(null)
                                }
                              }
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { column: "" } },
                                [
                                  _c("v-icon", [_vm._v("redo")]),
                                  _vm._v("\n              Repeat\n            ")
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        2
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db5c7a9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db5c7a9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/RepeatLoadTemplatesTool.vue
// module id = null
// module chunks = 